import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RfidCardsService } from '@services/entity/rfidCards.service';
import { UsersService } from '@services/entity/users.service';

@Component({
  selector: 'app-datasecurity',
  templateUrl: './datasecurity.component.html',
  styleUrls: ['./datasecurity.component.scss']
})
export class DatasecurityComponent extends AbstractDialogContent implements OnInit {

  public className = 'DatasecurityComponent';

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor(
    public activeModal: NgbActiveModal,
    private rfidCardService: RfidCardsService,
    private usersService: UsersService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  createForm() {

  }

  onSubmit(formValue) {
  }
}
